import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  AccountService,
  AnalyticsService,
  AuthorizationService,
  LoggingService,
} from "app/shared";
import { BaseDetailsComponent } from "../../../component/base-details/base-details.component";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import {
  BaseChartSettings,
  ManualsDownloadedConfig,
  UserAnalyticConfiguration,
} from "app/shared/model/charts/user-analytic-configurations.model";
import {
  ChartDefinition,
  ChartDefinitions,
} from "app/analytics/chartDefinitions.config";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

//TODO: This chart is incomplete, not in use

@Component({
  selector: "account-status-details",
  templateUrl: "./account-status-details.component.html",
  standalone: false,
})
export class AccountStatusDetailsComponent
  extends BaseDetailsLogic<ManualsDownloadedConfig>
  implements OnInit, OnDestroy
{
  //I am here, change type for DownloadedManualsConfig

  //TODO: Created A Shared Enum for Chart Types
  chartTypes = [
    "bar",
    "line",
    "pie",
    "doughnut",
    "polarArea",
    "radar",
    "bubble",
    "scatter",
  ];
  //TODO: Get User Analytics Configurations from Analytics Service
  //TODO: not using BaseSettings as is
  userConfiguration: any = {
    accountTypeConfig: new BaseChartSettings(),
  };
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(
      analyticsService,
      authService,
      loggingService,
      ManualsDownloadedConfig,
      tooltipCoordinator
    );
  }
  changeChartType(chartType: string) {
    console.error("Change Chart Type Not Implemented");
  }

  ngOnInit(): void {
    super.init();
    this.loggingService.log(
      "AccountStatusDetailsComponent ngOnInit - after super"
    );
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
    };
  }
}
